<template>
    <div v-if="currentCna">
        <b-row>
            <b-col cols="3">
                <BaseTextOutput label="First Name" :value="currentCna.firstName"/>
            </b-col>
            <b-col cols="3">
                <BaseTextOutput label="Last Name" :value="currentCna.lastName"/>
            </b-col>
            <b-col cols="3">
                <BaseTextOutput label="SSN" :value="currentCna.ssn4"/>
            </b-col>
        </b-row>
        <div v-if="currentCna.priorNames.length>0">
          <b-row>
            <b-col cols="12">
              Formerly known as:
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <ol>
                <li v-for="(priorName, index) in currentCna.priorNames" :key="index">
                  {{priorName.firstName+' '+priorName.lastName}}
                </li>
              </ol>
            </b-col>
          </b-row>
        </div>
        <b-row>
            <b-col>
                <BaseSelector v-model="currentCna.status"
                              label="Status"
                              :options="statusOptions"
                              slug="status"
                              :v="$v.currentCna.status"
                              setId="cnaStatusSelector"
                              @input="forceRefresh"
                />
            </b-col>
        </b-row>
        <b-row v-if="currentCna.status==='OTH'">
            <b-col>
                <BaseTextInput v-model="currentCna.otherStatus"
                               :v="$v.currentCna.otherStatus"
                               slug="otherStatus"
                               label="Other status:"/>
            </b-col>
        </b-row>
        <b-row class="align-bottom" v-if="currentCna.status==='ONC' || currentCna.status==='LOA' || currentCna.status==='OTH' || currentCna.status==='TER'">
            <b-col cols="8">
                <BaseDateOfBirthInput v-model="currentCna.lastWorkedDate"
                               :v="$v.currentCna.lastWorkedDate"
                               slug="lastWorkedDate"
                               :label="currentCna.status==='OTH'?'Last Worked Date as a Nurse Aide':'Last Worked Date'"
                               :messages="endDateMessages"
                               tip="Format: MM/DD/YYYY"
                />
            </b-col>
            <b-col cols="4">
                <b-button variant="secondary" class="m-2" @click="clearDate">Clear date</b-button>
            </b-col>
        </b-row>
        <b-row v-if="currentCna.status==='NWH'">
            <b-col>
                <div class="text-muted">
                    Checking this option will rescind verification and remove this CNA from your list.
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="0">
                <b-button variant="primary" class="m-2" @click="submit">Submit</b-button>
            </b-col>
            <b-col>
                <b-button variant="secondary" class="m-2" @click="hideStatusModal">Cancel</b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>

    import BaseTextInput from "@/components/templates/input/BaseTextInput";
    import BaseTextOutput from "@/components/templates/input/BaseTextOutput";
    import BaseSelector from "@/components/templates/input/BaseSelector";
    import {required, requiredIf} from 'vuelidate/lib/validators'
    import maxDate from "@/validators/maxDate";
    import BaseDateOfBirthInput from "@/components/templates/input/BaseDateOfBirthInput";
    import axios from 'axios';


    export default {
        name: "ProviderCNAStatusUpdate",

        components: {
            BaseTextOutput,
            BaseSelector,
            BaseDateOfBirthInput,
            BaseTextInput
        },
        props:{
            currentCna: Object,
            statusOptions: Array
        },
        data(){
            return{
                endDateMessages: {
                    minDate: 'Date must be after 01/01/1900.',
                    maxDate: 'Date cannot be in the future.'
                },
            }
        },
        methods: {
            forceRefresh(){ //validator breaks when switching to current or never worked here
                let temp = this.$v.currentCna.$model;
                this.$v.currentCna.$model=null;
                this.$v.currentCna.$model=temp;
                this.$v.$reset();
            },
            hideStatusModal(){
                this.$emit('hideStatusModal');
            },
            submit(){
                this.$v.$touch();
                if(this.$v.$invalid){
                    return;
                }
                let updatedCNA = Object.assign({}, this.currentCna);
                delete updatedCNA.certificateStatus;
                axios.put(`${process.env.VUE_APP_API_BASE_URL}/provider/cna/update`,updatedCNA)
                    .then(response=>{
                        this.$emit('success');
                    })
                    .catch(error=>{
                        this.$emit('failure');
                    })
                    .finally(()=>{
                        this.$emit('hideStatusModal');
                    })
            },
            clearDate(){
                this.currentCna.lastWorkedDate = null;
                this.forceRefresh();
            }
        },


        validations:{
            currentCna:
                {
                    required,
                    firstName: {required: false},
                    lastName: {required: false},
                    ssn4: {required: false},
                    status: {required},
                    otherStatus: {
                        required : requiredIf(function(){
                                return this.currentCna.status==='OTH';
                            }
                        )
                    },
                    lastWorkedDate: {
                        required: requiredIf(function(){
                                return this.currentCna.status==='ONC' || this.currentCna.status==='LOA' || this.currentCna.status==='TER' || this.currentCna.status==='OTH'
                            }
                        ),
                        maxDate: maxDate(new Date()),
                    },
                }
        }
    }
</script>

<style scoped>

</style>